import { Link } from "react-router-dom";
import { Stethoscope, Phone, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_NUMBER } from "../lib/api";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-full bg-emerald-500 flex items-center justify-center">
              <Stethoscope className="w-5 h-5 text-white" />
            </span>
            <span className="font-heading font-semibold text-lg text-white">Doktor<span className="text-emerald-400">Ke</span>Rumah</span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">{t("footer.tagline")}</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">{t("nav.services")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Wound Dressing</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Critical Care</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Blood Checkup</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Chronic Screening</Link></li>
            <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Minor Procedure</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">{t("nav.contact")}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-emerald-400" /> +{WHATSAPP_NUMBER}</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-emerald-400" /> Lembah Klang, Malaysia</li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-slate-500 hover:text-slate-300 transition-colors">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Doktor Ke Rumah. {t("footer.rights")}
      </div>
    </footer>
  );
};
